import { ArrowDown } from "lucide-react";
import { hero } from "../data/siteContent";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[92vh] w-full overflow-hidden flex items-center"
    >
      <img
        src={hero.image}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 hero-gradient" />

      <div className="relative z-10 container mx-auto px-6 md:px-10 pt-28 pb-20">
        <div className="max-w-4xl">
          <p
            data-testid="hero-eyebrow"
            className="text-xs md:text-sm tracking-[0.35em] uppercase text-white/80 mb-8 font-medium"
          >
            <span className="inline-block w-10 h-px bg-brand-red align-middle mr-4" />
            {hero.eyebrow}
          </p>
          <h1
            data-testid="hero-title"
            className="font-serif font-light text-white leading-[1.05] text-5xl md:text-6xl lg:text-7xl tracking-tight mb-8"
          >
            {hero.title}
          </h1>
          <p
            data-testid="hero-subtitle"
            className="text-white/85 text-base md:text-lg leading-relaxed max-w-2xl mb-10"
          >
            {hero.subtitle}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <button
              onClick={() => scrollTo("contact")}
              data-testid="hero-primary-cta"
              className="bg-brand-red hover:bg-brand-redHover text-white px-8 py-4 text-xs font-semibold tracking-widest uppercase transition-colors"
            >
              {hero.primaryCta}
            </button>
            <button
              onClick={() => scrollTo("showroom")}
              data-testid="hero-secondary-cta"
              className="border border-white/80 hover:bg-white hover:text-brand-charcoal text-white px-8 py-4 text-xs font-semibold tracking-widest uppercase transition-colors"
            >
              {hero.secondaryCta}
            </button>
          </div>

          <div
            data-testid="hero-trust"
            className="flex flex-wrap gap-x-6 gap-y-2 text-xs md:text-sm text-white/80 tracking-wide"
          >
            {hero.trust.map((t, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && (
                  <span className="w-1 h-1 rounded-full bg-brand-red mr-4" />
                )}
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={() => scrollTo("products")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/70 hover:text-white flex flex-col items-center gap-2 animate-pulse"
        aria-label="Scroll down"
        data-testid="hero-scroll-indicator"
      >
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <ArrowDown size={16} />
      </button>
    </section>
  );
}
